module.exports = __webpack_public_path__ + "static/img/mail.e860246.svg";